<template>
  <div>
    <PageTable
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
    >
      <PageHeader
        slot="header"
        ref="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageTable>
  </div>
</template>

<script>
import PageHeader from './header.vue'
import PageTable from './table.vue'
import BaseTable from '@/mixins/base-table'
export default {
  components: { PageHeader, PageTable },
  mixins: [BaseTable],
  props: {
    extrasParams: { type: Object, default: () => ({}) },
  },
  data() {
    return { usePage: true }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .expoTskInfoMeetingSelectionChooseFabricApi({
          ...form,
          ...this.page,
          ...this.extrasParams,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    choiceData() {
      return this.$refs.main.choiceData()
    },
  },
}
</script>
